import React from 'react';

export const SpotlightBottomRight: React.FC = () => (
  <svg className='tour-spotlight tour-spotlight-bottom-right' xmlns='http://www.w3.org/2000/svg' width='291' height='326' viewBox='0 0 291 326' fill='none'>
    <g filter='url(#filter0_f_bottomright)'>
      <path
        d='M380.562 44.8855L528.432 192.755L376.401 272.62L298.313 350.707L187.347 594.685L-15.0001 392.338L237.467 289.862L315.555 211.774L380.562 44.8855Z'
        fill='url(#paint0_linear_bottomright)'
      />
    </g>
    <g filter='url(#filter1_f_bottomright)' style={{ mixBlendMode: 'plus-lighter' }}>
      <path
        d='M437.768 78.4303L513.537 154.199L345.966 258.039L262.55 341.454L187.345 480.39L111.577 404.621L249.462 323.386L330.387 242.461L437.768 78.4303Z'
        fill='#D9D9D9'
      />
    </g>
    <defs>
      <filter
        id='filter0_f_bottomright'
        x='-115.057'
        y='-55.1713'
        width='743.546'
        height='749.913'
        filterUnits='userSpaceOnUse'
        colorInterpolationFilters='sRGB'
      >
        <feFlood floodOpacity='0' result='BackgroundImageFix' />
        <feBlend mode='normal' in='SourceGraphic' in2='BackgroundImageFix' result='shape' />
        <feGaussianBlur stdDeviation='50.0284' result='effect1_foregroundBlur_bottomright' />
      </filter>
      <filter id='filter1_f_bottomright' x='39.5356' y='6.3894' width='546.042' height='546.042' filterUnits='userSpaceOnUse' colorInterpolationFilters='sRGB'>
        <feFlood floodOpacity='0' result='BackgroundImageFix' />
        <feBlend mode='normal' in='SourceGraphic' in2='BackgroundImageFix' result='shape' />
        <feGaussianBlur stdDeviation='36.0205' result='effect1_foregroundBlur_bottomright' />
      </filter>
      <linearGradient id='paint0_linear_bottomright' x1='146.994' y1='230.343' x2='349.342' y2='432.69' gradientUnits='userSpaceOnUse'>
        <stop stopColor='#64CB7E' />
        <stop offset='1' stopColor='#0CC5B9' />
      </linearGradient>
    </defs>
  </svg>
);
